import ListTemplate from "components/ListTemplate";
import React from "react";
import Filters from "./Filters";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const ShowListExternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowListExternalFrontModel>();

  return <>
    <ListTemplate
      title={site.currentEnvironment.show.plural}
      filterSet="show_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Show.PaginatedExternalEnvironment}
      getId={item => item.showId}
      layout={cardLayout(viewModel)}
      filters={<Filters />}
      options={{
        exportOptions: {
          canExportList: site.permissions.show.canExportList,
          exportOptionsApi: window.CoreApi.Show.ExportOptionsForListExternalEnvironment
        }
      }}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default ShowListExternalApp;
